<template>
  <div class="concierge-fee-layout pt-2.5 pl-6 flex items-center" :class="{ 'concierge-fee-disabled': !hasSelectedTests }">
    <div class="flex-1">
      <div class="flex grid-cols-2 items-center" :class="hasSelectedTests ? 'cursor-pointer' : 'cursor-not-allowed'" @click="handleClickConciergeFee(false)">
        <img :src="checkboxSrc" :style="!hasSelectedTests ? 'opacity: 0.4' : ''" />
        <span class="concierge-discount-tag ml-3">$30 Off</span>
        <p class="concierge-fee-text-style-1 ml-3">{{ $t("CheckoutPage[\"$30 Off Concierge Blood Draw Service!\"]") }} </p>
      </div>
      <p class="concierge-fee-text-style-2 mt-2 ml-9 pb-2">{{ $t("CheckoutPage[\"A concierge phlebotomist collects your patient’s sample, at their home at their convenience. Quality, speed and reliable.\"]") }}</p>
    </div>
    <img class="ml-auto" src="@/assets/orderTest/checkout-page/concierge_fee_img.svg" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
  props: {
    conciergeFeeInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isAddConciergeFee: false,
      checkbox: {
        unchecked: require("@/assets/orderTest/checkout-page/concierge_fee_checkbox.svg"),
        checked: require("@/assets/orderTest/checkbox_checked_filled_white.svg")
      },
      hasSetConciergeFee: false,
    }
  },
  computed: {
    ...mapState(["currency"]),
    ...mapGetters("orderTest", ["selectedItemList"]),
    conciergeFee() {
      return this.conciergeFeeInfo ? this.conciergeFeeInfo.concierge_final_price : 0;
    },
    hasSelectedTests() {
      return this.selectedItemList && this.selectedItemList.length > 0;
    },
    checkboxSrc() {
      return this.isAddConciergeFee ? this.checkbox.checked : this.checkbox.unchecked;
    },
    ...mapState("orderTest/promotions", ["waiveConciergeFee"]),
    ...mapState("orderTest/order", { storeConciergeFee: "conciergeFee" })
  },
  watch: {
    waiveConciergeFee(newVal, oldVal){
      if (newVal) {
        this.handleClickConciergeFee(true);
      }
    },
    'storeConciergeFee.isUse'(newVal) {
      if (!newVal) {
        this.isAddConciergeFee = false;
      }
    },
    hasSelectedTests(newVal) {
      if (!newVal && this.isAddConciergeFee) {
        this.deselectConciergeFee();
      }
    }
  },
  mounted() {
    if (this.waiveConciergeFee) {
      this.handleClickConciergeFee(true);
    }
  },
  methods: {
    handleClickConciergeFee(isWaive) {
      if (!isWaive && !this.hasSelectedTests) {
        return;
      }
      // if is waive the coneirge fee, then select the concierge fee
      if (isWaive) {
        this.isAddConciergeFee = true;
      } else {
        this.isAddConciergeFee = !this.isAddConciergeFee;
      }
      this.$store.dispatch("orderTest/order/setConciergeFee", {
        amount: this.isAddConciergeFee ? this.conciergeFee : 0,
        isUse: this.isAddConciergeFee,
      });
      // if deselect, remove the coupon and set waive concierge fee to false
      if (!this.isAddConciergeFee) {
        this.$store.commit("orderTest/promotions/ADD_REMOVE_WAIVE_CONCIERGE_FEE_COUNT");
        this.$store.commit("orderTest/promotions/SET_WAIVE_CONCIERGE_FEE", false);
      }
    },
    deselectConciergeFee() {
      this.isAddConciergeFee = false;
      this.$store.dispatch("orderTest/order/setConciergeFee", {
        amount: 0,
        isUse: false,
      });
      this.$store.commit("orderTest/promotions/ADD_REMOVE_WAIVE_CONCIERGE_FEE_COUNT");
      this.$store.commit("orderTest/promotions/SET_WAIVE_CONCIERGE_FEE", false);
    }
  }
}
</script>

<style scoped>
.concierge-fee-layout {
  border-radius: 2px;
  border: 1px solid #E6E6E6;
  background: #EBF2EF;
}
.concierge-fee-text-style-1 {
  font-size: 16px;
  font-weight: 500;
  line-height: 16px; /* 100% */
}
.concierge-fee-text-style-2 {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.concierge-fee-disabled {
  opacity: 0.5;
  background: #E8E8E8;
}
.concierge-discount-tag {
  display: inline-flex;
  white-space: nowrap;
  padding: 4px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  background: #DF4430;
  color: #FFF;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.25px;
}
</style>